export default "__VITE_ASSET__DH3q9UZV__"